if (!Modernizr) {
    throw Error("Requires Modernizr to be present!");
}
export default Modernizr.passiveeventlisteners ? { passive: true } : false;
